/*************************************************
 * MaxCap
 * @exports
 * customFetchBase.ts
 * Created by vinoth kumar on  15/05/2024
 * Copyright © 2024 MaxCap. All rights reserved.
 *************************************************/

// Import necessary modules
import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { Mutex } from "async-mutex";
import { logout } from "./../slice/UserSlice";
import store from "./../SessionStorage";

// Define base URL for API requests
const baseUrl = process.env.REACT_APP_CUSTOMER_API_BASE_URL;

// Create a mutex to manage concurrent access
const mutex = new Mutex();

// Define base query function with authorization header logic
const baseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders: (headers) => {
    headers.set("Accept", "application/json");
    const user = store.get("user")
      ? JSON.parse(store.get("user")!)
      : null;
    if (user) {
      headers.set("authorization", `Bearer ${user?.token}`);
    }
    return headers;
  },
});


const customFetchBase = async (args: any, api: any, extraOptions: any) => {
  await mutex.waitForUnlock();

  const isCSVRequest =
    typeof args === 'string'
      ? args.includes('/users/export')
      : args?.url?.includes('/users/export');

  if (isCSVRequest) {
    const user = store.get("user") ? JSON.parse(store.get("user")!) : null;
    const fullUrl = `${baseUrl?.replace(/\/+$/, '')}/${(args.url ?? args).replace(/^\/+/, '')}`;

    const response = await fetch(fullUrl, {
      method: args.method || 'GET',
      headers: {
        ...(args.headers || {}),
        Accept: 'text/csv',
        ...(user?.token ? { Authorization: `Bearer ${user.token}` } : {}),
      },
    });

    const text = await response.text();

    return {
      data: text,
      status: response.status,
      statusText: response.statusText,
      headers: response.headers,
    };
  }

  let result = await baseQuery(args, api, extraOptions);

  if (result.error?.status === 401) {
    if (!mutex.isLocked()) {
      const release = await mutex.acquire();
      try {
        const user = store.get('user') ? JSON.parse(store.get('user')!) : null;
        if (user) {
          api.dispatch(logout({}));
          window.location.href = '/';
        }
      } finally {
        release();
      }
    } else {
      await mutex.waitForUnlock();
      result = await baseQuery(args, api, extraOptions);
    }
  }

  return result;
};

export default customFetchBase;